import { trackEvent } from 'shared/helpers/Analytics';

interface Event {
  name:
    | 'Driver Started Preferences'
    | 'Driver Completed Step 1 Business Type'
    | 'Driver Completed Step 2 Transport Type'
    | 'Driver Completed Step 3 Vehicle Details';
}

export function trackDriverPreferences(event: Event) {
  trackEvent(event.name);
}
